import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSummarizeStarinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M13 7.248a.75.75 0 0 1 0 1.5H2.996a.75.75 0 1 1 0-1.5zm8.004-4.002a.75.75 0 0 1 0 1.5H2.996a.75.75 0 1 1 0-1.5zM9 11.25a.75.75 0 0 1 0 1.5H2.996a.75.75 0 0 1 0-1.5zm-1 4.002a.75.75 0 0 1 0 1.5H2.995a.75.75 0 0 1 0-1.5z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M13 7.248a.75.75 0 0 1 0 1.5H2.996a.75.75 0 1 1 0-1.5zm8.004-4.002a.75.75 0 0 1 0 1.5H2.996a.75.75 0 1 1 0-1.5zM9 11.25a.75.75 0 0 1 0 1.5H2.996a.75.75 0 0 1 0-1.5zm-1 4.002a.75.75 0 0 1 0 1.5H2.995a.75.75 0 0 1 0-1.5zm13.005 4.001a.75.75 0 0 1 0 1.5H2.996a.75.75 0 0 1 0-1.5zM17.003 7.248a.75.75 0 0 1 .75.75l.004.167a3.25 3.25 0 0 0 3.08 3.08l.167.005.077.004a.75.75 0 0 1-.077 1.496 3.253 3.253 0 0 0-3.252 3.251v.001l-.003.076a.751.751 0 0 1-1.496-.076A3.253 3.253 0 0 0 13 12.75a.8.8 0 0 1-.292-.059.7.7 0 0 1-.163-.098.747.747 0 0 1-.295-.593.75.75 0 0 1 .75-.75l.167-.004a3.253 3.253 0 0 0 3.085-3.248.75.75 0 0 1 .75-.75m-.001 3.31A4.8 4.8 0 0 1 15.561 12c.577.37 1.07.862 1.44 1.44.37-.578.864-1.07 1.442-1.441a4.8 4.8 0 0 1-1.441-1.441"
	})]
});
export default SvgSummarizeStarinline;
